/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ArchiveSoftwareBody
 */
export interface ArchiveSoftwareBody {
  /**
   *
   * @type {string}
   * @memberof ArchiveSoftwareBody
   */
  softwareId: string;
}

/**
 * Check if a given object implements the ArchiveSoftwareBody interface.
 */
export function instanceOfArchiveSoftwareBody(
  value: object,
): value is ArchiveSoftwareBody {
  if (!("softwareId" in value) || value["softwareId"] === undefined)
    return false;
  return true;
}

export function ArchiveSoftwareBodyFromJSON(json: any): ArchiveSoftwareBody {
  return ArchiveSoftwareBodyFromJSONTyped(json, false);
}

export function ArchiveSoftwareBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ArchiveSoftwareBody {
  if (json == null) {
    return json;
  }
  return {
    softwareId: json["softwareId"],
  };
}

export function ArchiveSoftwareBodyToJSON(json: any): ArchiveSoftwareBody {
  return ArchiveSoftwareBodyToJSONTyped(json, false);
}

export function ArchiveSoftwareBodyToJSONTyped(
  value?: ArchiveSoftwareBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    softwareId: value["softwareId"],
  };
}
